import { getNetworkErrorMessage } from '@framework/auth';
import {
  IWidgetComponentProps,
  getWidgetProps,
  useExpressionValue,
} from '@framework/engine';
import { useTranslation } from '@framework/i18n';
import { Alert } from 'antd';
import React, { useMemo } from 'react';
import { useGetMicOrganicoIstitutoCodAoo } from '../../../api/employee/dati-dipendente-controller/dati-dipendente-controller';
import { ISiapDataWidget } from './ISiapDataWidget';
import { SiapDataTable } from './components/SiapDataTable';

export interface ISiapDataWidgetComponentProps
  extends IWidgetComponentProps<ISiapDataWidget> {}

export function SiapDataWidgetComponent(props: ISiapDataWidgetComponentProps) {
  const options = getWidgetProps(props);
  const { t } = useTranslation();
  const aooExpressionValue = useExpressionValue(
    options.name,
    props.widget.aooField,
  );

  const aooCode = useMemo(() => {
    if (aooExpressionValue.type === 'null') {
      return null;
    }

    const value = aooExpressionValue.result;

    if (typeof value !== 'string') {
      console.warn(`[SiapDataWidgetComponent] Il campo ${options.name} non è di tipo stringa`, { aooExpressionValue, aooField: props.widget.aooField }); // prettier-ignore
      return null;
    }

    return value;
  }, [aooExpressionValue, options.name, props.widget.aooField]);

  const { data, isLoading, error, isError } = useGetMicOrganicoIstitutoCodAoo(
    aooCode ?? '<unknown>',
    {
      query: {
        enabled: Boolean(aooCode),
      },
    },
  );

  if (isError) {
    return (
      <Alert
        type="error"
        message={t(
          'siap-data-widget.error-message',
          'Errore durante il caricamento dei dati',
        )}
        description={getNetworkErrorMessage(
          error,
          t(
            'siap-data-widget.error-message-description',
            'Si è verificato un errore durante il caricamente dei dati da SIAP. Riprovare più tardi.',
          ),
        )}
      />
    );
  }

  return <SiapDataTable data={data?.data} loading={isLoading} />;
}
